<template>
    <div class="menu paddingHeader">
		<div class="menu__mask zIndex1" v-show="choseItem === -1"></div>
        <img v-for="item in list" :key="item.id" :src="item.img" :class="item.floor === 1 ? 'menu__mask_img__chose' : ''" class="menu__mask_img zIndex-1">
		<div v-show="choseItem !== -1" class="menu__mask_mask zIndex1" ></div>
		<div class="menu__list">
			<div class="menu__list_item" v-for="(item,index) in list" :key="index" @mouseenter="enter(item.id)" @mouseleave="leave(index)" @click="jumpFn(index)">
				<div :class="choseItem === item.id ? 'menu__list_item_chose' : ''">{{item.name}}</div>
				<img src='https://static.zc0901.com/dci-web-menu-list-img.png' />
			</div>
		</div>
    </div>
</template>
<script>
import { mapGetters,mapState,mapMutations,mapActions } from 'vuex'
import img1 from '@/static/inspiration1.jpg'
import img2 from '@/static/inspiration2.jpg'
import img3 from '@/static/inspiration3.jpg'
import img4 from '@/static/inspiration4.jpg'
import img5 from '@/static/inspiration5.jpg'
	export default {
		data() {
			return {
				choseItem:-1,
				list:[
					{
						id:0,
						img:img1,
						name:'品牌故事',
						floor:0,
					},{
						id:1,
						img:img2,
						name:'产品系列',
						floor:0,
					},{
						id:2,
						img:img3,
						name:'工艺特点',
						floor:0,
					}
					,{
						id:3,
						img:img4,
						name:'铺贴保养',
						floor:0,
					}
					,{
						id:4,
						img:img5,
						name:'联系我们',
						floor:0,
					}
				]
			}
		},
		computed: {

		},
        async created(){

        },
		mounted() {
			
		},

		methods: {
			...mapMutations('common',['setShowMenu']),
			enter(index){
				this.choseItem = index
				this.list.forEach((item)=>{
					item.floor = 0
				})
				this.list[index].floor = 1
			},
			leave(index){
				this.list[index].floor = 0
				this.choseItem = -1
			},
			jumpFn(index){
				let _url = index === 0 ? 'brand' : index === 1 ? 'series' : index === 2 ? 'characteristics' : index === 3 ? 'service' : 'contact'
				this.setShowMenu(true)
				this.$router.push({
					path: `../${_url}`
				})
			}
		}
	}
</script>
<style scoped lang="scss">
	.menu{
		width: 100%;
		height: 100vh;
		overflow: hidden;
		.menu__mask_img{
			width:100%;
			height:100vh;
			position: absolute;
			top: 0;
			left: 0;
			overflow: hidden;
		}
		.menu__mask_img__chose{
			z-index: 1;
		}
		.menu__mask_mask{
			width: 100%;
			height: 100vh;
			background: rgba(0,0,0,1);
			opacity: 0.3;
			position: absolute;
			top: 0;
			left: 0;
		}
	}
    .menu__mask{
		width:100%;
		height:100vh;
		background:rgba(19,26,37,1);
		position: absolute;
		top: 0;
	}
	.menu__list{
		width: 100%;
		height: 100%;
		margin: -110px auto 0;
		// background: rgba(0,0,0,.3);
		padding-top: 110px;
		box-sizing: border-box;
		position: absolute;
		z-index: 10;
	}
	.menu__list_item{
		position: relative;
		width: 1040px;
		height: 150px;
		display: flex;
		align-items: center;
		margin: 0 auto;
		flex-wrap: wrap;
		cursor: pointer;
		div{
			font-size:32px;
			font-weight:600;
			color:rgba(153,153,153,1);
			margin: 0 auto;
			line-height: 150px;
		}
		.menu__list_item_chose{
			color:rgba(255,255,255,1);
		}
		img{
			width: 100%;
			height: 2px;
		}
	}
	
</style>
